import React from 'react'
import Home from "./Home";

import About from './About';
import SocialMediaSection from './SocialMediaScetion';




const Homepage = () => {
  return (
    <>
    <Home/>
    <SocialMediaSection/> 
    
      <About/>
    
     
        
       
    </>
  )
}

export default Homepage
